import { render, staticRenderFns } from "./navjxlh.vue?vue&type=template&id=1b4c1f81&scoped=true&"
import script from "./navjxlh.vue?vue&type=script&lang=js&"
export * from "./navjxlh.vue?vue&type=script&lang=js&"
import style0 from "./navjxlh.vue?vue&type=style&index=0&id=1b4c1f81&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b4c1f81",
  null
  
)

export default component.exports